// Mock data for Formation du Dragon

export const companyInfo = {
  name: "Formation du Dragon",
  phone: "06 15 42 46 73",
  email: "formationdudragon@gmail.com",
  logo: "https://customer-assets.emergentagent.com/job_learning-platform-79/artifacts/q7w1amlo_logo_transparent_background.png"
};

// Prestations en organisme (interventions externes)
export const prestationsOrganisme = [
  {
    id: 1,
    slug: "incendie",
    title: "Incendie",
    description: "Formations complètes en sécurité incendie",
    image: "https://images.unsplash.com/photo-1575867094974-9e16b6f55360",
    formationsCount: 11,
    formations: [
      { id: 1, name: "Exercice Evacuation", duration: "1 Heure 30", price: "150€" },
      { id: 2, name: "Formation Evacuation", duration: "3 Heures", price: "150€" },
      { id: 3, name: "Formation Manipulation des extincteurs", duration: "3 Heures", price: "200€" },
      { id: 4, name: "Formation Initiation extincteurs", duration: "1 Heure 30", price: "140€" },
      { id: 5, name: "Formation Manipulation du SSI", duration: "1 Heure 30", price: "130€" },
      { id: 6, name: "Formation Demi-journée incendie", duration: "4 Heures", price: "220€" },
      { id: 7, name: "Formation Demi-journée incendie recyclage", duration: "4 Heures", price: "220€" },
      { id: 8, name: "Formation Préparation incendie", duration: "2 Heures 30", price: "150€" },
      { id: 9, name: "Formation Journée incendie", duration: "6 Heures", price: "340€" },
      { id: 10, name: "Formation Demi-journée évacuation", duration: "3 Heures", price: "200€" },
      { id: 11, name: "Formation Prévention des risques incendie", duration: "2 Heures", price: "140€" }
    ]
  },
  {
    id: 2,
    slug: "secourisme",
    title: "Secourisme",
    description: "Formations aux gestes de premiers secours",
    image: "https://images.unsplash.com/photo-1622115585848-1d5b6e8af4e4",
    formationsCount: 7,
    formations: [
      { id: 1, name: "Formation Devenir SST", duration: "14 Heures", price: "500€" },
      { id: 2, name: "Formation MAC SST", duration: "7 Heures", price: "250€" },
      { id: 3, name: "Formation Initiation à la manipulation du défibrillateur", duration: "2 Heures", price: "220€" },
      { id: 4, name: "Formation Demi-journée secourisme", duration: "4 Heures", price: "220€" },
      { id: 5, name: "Formation Premiers secours", duration: "7 Heures", price: "250€" },
      { id: 6, name: "Formation Gestes et Postures", duration: "4 heures", price: "220€" },
      { id: 7, name: "Formation Premiers secours canin et félin", duration: "7 Heures", price: "250€", available: false }
    ]
  },
  {
    id: 3,
    slug: "prevention-securite",
    title: "Prévention sécurité",
    description: "Formations en prévention des risques professionnels",
    image: "https://images.unsplash.com/photo-1601021545082-4385509b3074",
    formationsCount: 2,
    formations: [
      { id: 1, name: "Formation ATEX", duration: "3 heures 30", price: "220€" },
      { id: 2, name: "Formation Espace confiné sans mise en situation pratique", duration: "6 Heures", price: "350€" }
    ]
  },
  {
    id: 4,
    slug: "habilitation-electrique",
    title: "Habilitation électrique",
    description: "Formations en habilitation électrique",
    image: "https://images.unsplash.com/photo-1636218685495-8f6545aadb71",
    formationsCount: 1,
    formations: [
      { id: 1, name: "Formation Habilitations Electrique H0B0", duration: "7 Heures", price: "240€" }
    ]
  },
  {
    id: 5,
    slug: "securite-privee",
    title: "Sécurité privée",
    description: "Formations en sécurité privée et SSIAP",
    image: "https://images.unsplash.com/photo-1618371690240-e0d46eead4b8",
    formationsCount: 3,
    formations: [
      { id: 1, name: "Formation TFP APS", duration: "175 Heures", price: "250€/j" },
      { id: 2, name: "Mac APS", duration: "27 Heures", price: "250€/j" },
      { id: 3, name: "SSIAP 1,2,3 initiale, RAN, REC", duration: "Variable", price: "250€/j" }
    ]
  },
  {
    id: 6,
    slug: "risque-attentat",
    title: "Sécurité liée au risque attentat",
    description: "Formations protocoles de mise en sûreté",
    image: "https://images.unsplash.com/photo-1696910873421-b014de91f014",
    formationsCount: 2,
    formations: [
      { id: 1, name: "Formation à la mise en place du Protocole de Mise en Sureté", duration: "3 Heures", price: "220€" },
      { id: 2, name: "Exercice de mise en sureté", duration: "1 Heure 30", price: "130€" }
    ]
  }
];

// Formations internes (sessions organisées par Formation du Dragon)
export const formationsInternes = [
  {
    id: 1,
    slug: "ssiap",
    title: "SSIAP",
    description: "Service de Sécurité Incendie et d'Assistance à Personnes",
    image: "https://images.unsplash.com/photo-1575867094974-9e16b6f55360",
    formationsCount: 9,
    formations: [
      { id: 1, name: "SSIAP 1 - Initiale", duration: "67 heures (10 jours)", price: "850€", cpf: true },
      { id: 2, name: "SSIAP 1 - Remise à Niveau (RAN)", duration: "21 heures (3 jours)", price: "300€", cpf: true },
      { id: 3, name: "SSIAP 1 - Recyclage (MAC)", duration: "14 heures (2 jours)", price: "200€", cpf: true },
      { id: 4, name: "SSIAP 2 - Initiale", duration: "70 heures", price: "1200€", cpf: true },
      { id: 5, name: "SSIAP 2 - Remise à Niveau (RAN)", duration: "21 heures (3 jours)", price: "400€", cpf: true },
      { id: 6, name: "SSIAP 2 - Recyclage (MAC)", duration: "14 heures (2 jours)", price: "300€", cpf: true },
      { id: 7, name: "SSIAP 3 - Initiale", duration: "216 heures", price: "3950€", cpf: true },
      { id: 8, name: "SSIAP 3 - Remise à Niveau (RAN)", duration: "35 heures (5 jours)", price: "800€", cpf: true },
      { id: 9, name: "SSIAP 3 - Recyclage (MAC)", duration: "21 heures (3 jours)", price: "500€", cpf: true }
    ]
  },
  {
    id: 2,
    slug: "incendie-interne",
    title: "Incendie",
    description: "Formations en prévention et lutte contre l'incendie",
    image: "https://images.unsplash.com/photo-1640145867966-be8e200a7891",
    formationsCount: 8,
    formations: [
      { id: 1, name: "Manipulation des extincteurs", duration: "3 heures", price: "180€" },
      { id: 2, name: "Évacuation incendie", duration: "2 heures", price: "150€" },
      { id: 3, name: "Equipier de Première Intervention (EPI)", duration: "7 heures", price: "250€" },
      { id: 4, name: "Equipier d'Évacuation et Guide-File", duration: "3 heures", price: "180€" },
      { id: 5, name: "Manipulation Système de Sécurité Incendie (SSI)", duration: "3 heures", price: "200€" },
      { id: 6, name: "Première intervention incendie", duration: "4 heures", price: "220€" },
      { id: 7, name: "Chef d'équipe incendie", duration: "7 heures", price: "280€" },
      { id: 8, name: "Sensibilisation incendie", duration: "2 heures", price: "140€" }
    ]
  },
  {
    id: 3,
    slug: "securite-privee-interne",
    title: "Sécurité privée",
    description: "Formations professionnelles en sécurité et surveillance",
    image: "https://images.unsplash.com/photo-1618371690240-e0d46eead4b8",
    formationsCount: 5,
    formations: [
      { id: 1, name: "TFP Agent de Prévention et de Sécurité (APS)", duration: "175 heures", price: "1990€", cpf: true },
      { id: 2, name: "MAC APS (Recyclage)", duration: "31 heures", price: "450€", cpf: true },
      { id: 3, name: "CQP Agent de Sécurité Cynophile", duration: "70 heures", price: "1200€", cpf: true },
      { id: 4, name: "Agent de sûreté aéroportuaire", duration: "63 heures", price: "950€", cpf: true },
      { id: 5, name: "Prévention des actes terroristes", duration: "7 heures", price: "250€" }
    ]
  },
  {
    id: 4,
    slug: "secourisme-interne",
    title: "Secourisme et SST",
    description: "Sauveteur Secouriste du Travail et premiers secours",
    image: "https://images.unsplash.com/photo-1622115585848-1d5b6e8af4e4",
    formationsCount: 4,
    formations: [
      { id: 1, name: "SST - Formation initiale", duration: "14 heures (2 jours)", price: "250€", cpf: true },
      { id: 2, name: "MAC SST - Recyclage", duration: "7 heures (1 jour)", price: "140€", cpf: true },
      { id: 3, name: "Gestes et postures de travail", duration: "7 heures", price: "200€" },
      { id: 4, name: "Utilisation du défibrillateur (DAE)", duration: "4 heures", price: "150€" }
    ]
  }
];

// Mock sessions for calendar
export const mockSessions = [
  {
    id: "1",
    formationType: "interne",
    category: "SSIAP",
    formationName: "SSIAP 1 - Initiale",
    startDate: "2026-04-15",
    endDate: "2026-04-26",
    location: "Paris",
    availableSeats: 12,
    totalSeats: 15,
    price: "850€",
    status: "open"
  },
  {
    id: "2",
    formationType: "interne",
    category: "Secourisme",
    formationName: "SST - Formation initiale",
    startDate: "2026-04-08",
    endDate: "2026-04-09",
    location: "Lyon",
    availableSeats: 8,
    totalSeats: 10,
    price: "250€",
    status: "open"
  },
  {
    id: "3",
    formationType: "interne",
    category: "SSIAP",
    formationName: "SSIAP 1 - Recyclage (MAC)",
    startDate: "2026-03-25",
    endDate: "2026-03-26",
    location: "Paris",
    availableSeats: 0,
    totalSeats: 12,
    price: "200€",
    status: "full"
  }
];